module.exports = __webpack_public_path__ + "static/media/lp2-image-2.a035ccb4.png";